"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const db_mapper_1 = __importDefault(require("../base/db-mapper"));
const agent_model_1 = __importDefault(require("./agent.model"));
const agent_schema_1 = require("./agent.schema");
const aws_sdk_1 = require("aws-sdk");
const company_1 = require("../company");
class AgentMapper extends db_mapper_1.default {
    constructor() {
        super(...arguments);
        this._credentials = {};
        this.findUserFromUserName = async (companyID, instanceID, username, nextPageToken) => {
            var _a;
            const connect = await this.getConnectInstance(companyID, instanceID);
            const results = await connect
                .listUsers({
                InstanceId: instanceID,
                NextToken: nextPageToken,
                MaxResults: 1000,
            })
                .promise();
            const user = (_a = results.UserSummaryList) === null || _a === void 0 ? void 0 : _a.find((user) => { var _a; return ((_a = user.Username) === null || _a === void 0 ? void 0 : _a.trim()) === username; });
            console.log("found user", user);
            return user
                ? user
                : results.NextToken
                    ? await this.findUserFromUserName(companyID, instanceID, username, results.NextToken)
                    : undefined;
        };
    }
    async load(ID, companyID, instanceID, loadFromConnect = true) {
        let agent;
        try {
            agent = await super.load(ID);
            //If not passed in try get off DB
            if (!companyID || !instanceID) {
                //We need the companyID and instanceID to load up the agent
                if (!agent)
                    return;
                companyID = agent.companyID;
                instanceID = agent.instanceID;
            }
            if (loadFromConnect) {
                const connect = await this.getConnectInstance(companyID, instanceID);
                try {
                    const response = await connect
                        .describeUser({
                        InstanceId: instanceID,
                        UserId: ID,
                    })
                        .promise();
                    const { User } = response;
                    if (!User)
                        return;
                    //Create if not in database
                    if (!agent) {
                        agent = this.newModelFromConnectUser(companyID, instanceID, User);
                        await agent.commit();
                    }
                    else {
                        await this.updateAgentFromConnectUser(agent, User);
                    }
                }
                catch (error) {
                    console.error(error);
                }
            }
            return agent;
        }
        catch (ex) {
            //If resource not found or invalid param just return
            if (ex.code === "ResourceNotFoundException" ||
                ex.code === "InvalidParameterException") {
                console.log(JSON.stringify(ex, null, 2));
                if (agent)
                    await agent.delete(false);
                return;
            }
            throw ex;
        }
    }
    async updateAgentFromConnectUser(agent, user) {
        await agent._updateInternals({
            routingProfileID: user.RoutingProfileId,
            securityGroupIDs: user.SecurityProfileIds,
            hierarchyGroupID: user.HierarchyGroupId || undefined,
            firstName: user.IdentityInfo.FirstName,
            lastName: user.IdentityInfo.LastName,
            email: user.IdentityInfo.Email || undefined,
            phoneType: user.PhoneConfig.PhoneType || undefined,
            autoAccept: user.PhoneConfig.AutoAccept,
            afterWorkTimeLimit: user.PhoneConfig.AfterContactWorkTimeLimit,
            deskPhoneNumber: user.PhoneConfig.DeskPhoneNumber || undefined,
            tags: user.Tags
        });
    }
    newModelFromConnectUser(companyID, instanceID, user) {
        return this.newModel(Object.assign({ companyID,
            instanceID }, this.convertConnectUserToAgent(user)));
    }
    convertConnectUserToAgent(user) {
        return {
            ID: user.Id,
            username: user.Username,
            firstName: user.IdentityInfo.FirstName,
            lastName: user.IdentityInfo.LastName,
            email: user.IdentityInfo.Email || undefined,
            afterWorkTimeLimit: user.PhoneConfig.AfterContactWorkTimeLimit,
            routingProfileID: user.RoutingProfileId,
            securityGroupIDs: user.SecurityProfileIds,
            hierarchyGroupID: user.HierarchyGroupId || undefined,
            phoneType: user.PhoneConfig.PhoneType || undefined,
            autoAccept: user.PhoneConfig.AutoAccept,
            deskPhoneNumber: user.PhoneConfig.DeskPhoneNumber || undefined,
            tags: user.Tags
        };
    }
    async getConnectInstance(companyID, instanceID) {
        var _a;
        if (this._credentials[instanceID] &&
            ((_a = this._credentials[instanceID]) === null || _a === void 0 ? void 0 : _a.expiry) > new Date(Date.now() + 1000)) {
            return new aws_sdk_1.Connect(this._credentials[instanceID]);
        }
        const companyMapper = (0, company_1.getCompanyMapper)();
        const company = await companyMapper.load(companyID);
        if (!company)
            throw "Company not found";
        this._credentials[instanceID] = await company.getCredentials(instanceID);
        return new aws_sdk_1.Connect(this._credentials[instanceID]);
    }
    async determineSecurityRoles(agent, cachedSecurityProfiles) {
        const connect = await this.getConnectInstance(agent.companyID, agent.instanceID);
        let securityProfileList = cachedSecurityProfiles;
        if (!securityProfileList || securityProfileList.length === 0) {
            const securityProfilesResponse = await connect
                .listSecurityProfiles({
                InstanceId: agent.instanceID,
            })
                .promise();
            securityProfileList = securityProfilesResponse.SecurityProfileSummaryList;
        }
        const securityRoles = [agent_schema_1.Role.USER];
        if (!securityProfileList) {
            return securityRoles;
        }
        agent.securityGroupIDs.forEach((profileID) => {
            const securityProfile = securityProfileList === null || securityProfileList === void 0 ? void 0 : securityProfileList.find((sp) => sp.Id === profileID);
            if (!(securityProfile === null || securityProfile === void 0 ? void 0 : securityProfile.Name))
                return;
            const name = securityProfile.Name.replace(/ /g, "").toUpperCase();
            switch (name) {
                case "ADMIN":
                    securityRoles.push(agent_schema_1.Role.ADMIN);
                    break;
                case "CALLCENTERMANAGER":
                case "SUPERVISOR":
                    securityRoles.push(agent_schema_1.Role.SUPERVISOR);
                    break;
                case "QAADMIN":
                case "QUALITYANALYSTADMIN":
                    securityRoles.push(agent_schema_1.Role.QA_ADMIN);
                    break;
                case "QA":
                case "QUALITYANALYST":
                    securityRoles.push(agent_schema_1.Role.QA);
                    break;
                case "AGENT":
                    securityRoles.push(agent_schema_1.Role.AGENT);
                    break;
                case "REPORTING":
                    securityRoles.push(agent_schema_1.Role.REPORTING);
                    break;
                case "USEREDIT":
                    securityRoles.push(agent_schema_1.Role.USER_EDIT);
                    break;
                case "CALLDOWNLOAD":
                    securityRoles.push(agent_schema_1.Role.CALL_DOWNLOAD);
                    break;
                case "LIVEMONITORING":
                    securityRoles.push(agent_schema_1.Role.LIVE_MONITORING);
                    break;
                case "LINEMANAGEMENT":
                    securityRoles.push(agent_schema_1.Role.LINE_MANAGEMENT);
                    break;
                default:
                    securityRoles.push(name);
                    break;
                    //TODO add in company specific mappings
                    break;
            }
        });
        return securityRoles;
    }
    async determineHierarchyStructure(agent) {
        return this.getHierarchyStructure(agent.companyID, agent.instanceID, agent.hierarchyGroupID);
    }
    async getHierarchyStructure(companyID, instanceID, hierarchyGroupID) {
        if (!hierarchyGroupID)
            return;
        const connect = await this.getConnectInstance(companyID, instanceID);
        const hierarchyStructure = await connect
            .describeUserHierarchyGroup({
            InstanceId: instanceID,
            HierarchyGroupId: hierarchyGroupID,
        })
            .promise();
        if (!hierarchyStructure.HierarchyGroup)
            return;
        const { HierarchyGroup: { HierarchyPath }, } = hierarchyStructure;
        if (!HierarchyPath)
            return;
        const levels = [];
        const { LevelOne, LevelTwo, LevelThree, LevelFour, LevelFive } = HierarchyPath;
        if (LevelOne)
            levels.push(LevelOne.Id);
        if (LevelTwo)
            levels.push(LevelTwo.Id);
        if (LevelThree)
            levels.push(LevelThree.Id);
        if (LevelFour)
            levels.push(LevelFour.Id);
        if (LevelFive)
            levels.push(LevelFive.Id);
        return levels.join("/");
    }
    async create(data) {
        const { password } = data, others = __rest(data, ["password"]);
        const companyMapper = (0, company_1.getCompanyMapper)();
        const company = await companyMapper.load(data.companyID);
        if (!company)
            throw "Company not found";
        const isSAML = company.identityManagement && company.identityManagement !== "connect";
        const connect = await this.getConnectInstance(data.companyID, data.instanceID);
        const response = await connect
            .createUser({
            InstanceId: data.instanceID,
            Username: data.username,
            IdentityInfo: {
                Email: (!isSAML && data.email) || undefined,
                FirstName: data.firstName,
                LastName: data.lastName,
            },
            RoutingProfileId: data.routingProfileID,
            SecurityProfileIds: data.securityGroupIDs,
            HierarchyGroupId: data.hierarchyGroupID,
            PhoneConfig: {
                PhoneType: data.phoneType,
                AfterContactWorkTimeLimit: data.afterWorkTimeLimit,
                AutoAccept: data.autoAccept,
                DeskPhoneNumber: data.deskPhoneNumber,
            },
            Password: password,
        })
            .promise();
        others.ID = response.UserId;
        const agent = this.newModel(others);
        agent.securityRoles = await this.determineSecurityRoles(agent);
        await agent.commit();
        return agent;
    }
    async connectUpdates(agent) {
        //Update to connect
        const connect = await this.getConnectInstance(agent.companyID, agent.instanceID);
        const promises = [];
        const updates = agent.getUpdates();
        const companyMapper = (0, company_1.getCompanyMapper)();
        const company = await companyMapper.load(agent.companyID);
        if (!company)
            throw "Company not found";
        const isSAML = company.identityManagement && company.identityManagement !== "connect";
        if (updates.includes("securityGroupIDs")) {
            promises.push(connect
                .updateUserSecurityProfiles({
                InstanceId: agent.instanceID,
                UserId: agent.ID,
                SecurityProfileIds: agent.securityGroupIDs,
            })
                .promise());
        }
        if (updates.includes("hierarchyGroupID")) {
            promises.push(connect
                .updateUserHierarchy({
                InstanceId: agent.instanceID,
                UserId: agent.ID,
                HierarchyGroupId: agent.hierarchyGroupID || undefined,
            })
                .promise());
        }
        if (updates.includes("routingProfileID")) {
            promises.push(connect
                .updateUserRoutingProfile({
                InstanceId: agent.instanceID,
                UserId: agent.ID,
                RoutingProfileId: agent.routingProfileID,
            })
                .promise());
        }
        if (updates.includes("identityInfo")) {
            promises.push(connect
                .updateUserIdentityInfo({
                InstanceId: agent.instanceID,
                UserId: agent.ID,
                IdentityInfo: {
                    FirstName: agent.firstName,
                    LastName: agent.lastName,
                    Email: (!isSAML && agent.email) || undefined,
                },
            })
                .promise());
        }
        if (updates.includes("phoneConfig")) {
            promises.push(connect
                .updateUserPhoneConfig({
                InstanceId: agent.instanceID,
                UserId: agent.ID,
                PhoneConfig: {
                    AfterContactWorkTimeLimit: agent.afterWorkTimeLimit,
                    AutoAccept: agent.autoAccept,
                    PhoneType: agent.phoneType,
                    DeskPhoneNumber: agent.deskPhoneNumber,
                },
            })
                .promise());
        }
        await Promise.all(promises);
        agent.clearUpdates();
    }
    async commit(agent) {
        if (agent.ID === "new") {
            throw new Error("Agent needs creating through connect first");
        }
        if (agent.hasUpdates()) {
            await this.connectUpdates(agent);
        }
        if (!agent.securityRoles)
            agent.securityRoles = await this.determineSecurityRoles(agent);
        if (!agent.hierarchyStructure)
            agent.hierarchyStructure = await this.determineHierarchyStructure(agent);
        return await super.commit(agent);
    }
    async delete(agent, hardDelete = true) {
        if (hardDelete) {
            const connect = await this.getConnectInstance(agent.companyID, agent.instanceID);
            try {
                await connect
                    .deleteUser({
                    InstanceId: agent.instanceID,
                    UserId: agent.ID,
                })
                    .promise();
            }
            catch (ex) {
                //If already deleted just delete dynamo entry
                if (ex.code !== "ResourceNotFoundException") {
                    throw ex;
                }
            }
        }
        await super.delete(agent);
    }
    async getAgentsUnderHierarchyGroup(companyID, instanceID, hierarchyGroupID) {
        const hierarchyStructure = await this.getHierarchyStructure(companyID, instanceID, hierarchyGroupID);
        if (!hierarchyStructure)
            return [];
        return this.query({
            index: "instanceID-hierarchyStructure",
            conditions: {
                instanceID,
                hierarchyStructure: {
                    comparator: "BEGINS_WITH",
                    value: hierarchyStructure,
                },
            },
        });
    }
    async getAgentByUsername(companyID, instanceID, username, loadFromConnect = true) {
        //Check first if the agent is in dynamo
        const agents = await this.query({
            index: "instanceID-username",
            conditions: {
                instanceID,
                username,
            },
        }).catch(() => []); //Just return empty array if errors
        //Make sure these agents still exist in connect by loading them up
        while (agents.length) {
            const agent = agents[0];
            const a = await this.load(agent.ID, companyID, instanceID, loadFromConnect);
            if (a)
                return a;
            agents.shift();
        }
        //Else get agent from connect
        const user = await this.findUserFromUserName(companyID, instanceID, username);
        if (!user)
            return;
        return this.load(user.Id, companyID, instanceID, loadFromConnect);
    }
    clearCache() {
        this._credentials = {};
    }
}
exports.default = db_mapper_1.default.registerModel("agent", agent_model_1.default, AgentMapper);
